<template>
<div class="containers">
    <div class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="6">
                    <input type="text" v-model="idPegawai" placeholder="Cari Pegawai" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="selectedStatus" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2">
                    <input type="date" v-model="searchTanggal" placeholder="Tanggal Pelaksanaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton style="width: 100%!important" @click="modalAdd = true" class="btn-cancel">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalApprove"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div :style="modalKeterangan==true&&'background-color:grey'" class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Konfirmasi Hasil Tes Mandiri Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalApprove = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div :style="modalKeterangan==true&&'background-color:grey'" style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="3">
                            Nama
                        </CCol>
                        <CCol sm="9">
                            :  <span class="font-weight-bold">{{dataModal.nama}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            NIP
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.nik}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nomor KTP
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.noKtp}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Lahir
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.tanggalLahir}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Nama Atasan
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.namaAtasan}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Jenis Tes Mandiri
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.jenisTest}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Tanggal Tes Mandiri
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.tanggalHasil}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="3">
                            Hasil Tes Mandiri
                        </CCol>
                        <CCol sm="9">
                            :  {{dataModal.hasilRta}}
                        </CCol>
                    </CRow>
                    <CRow class="mt-2 mb-4">
                        <CCol sm="3">
                            File Bukti
                        </CCol>
                        <CCol sm="9">
                            <span v-if="dataModal.urlFile == null || dataModal.urlFile == 'null' || dataModal.urlFile == '' || dataModal.urlFile == undefined">
                            : -
                            </span>
                            <CButton v-if="dataModal.urlFile != null && dataModal.urlFile != 'null' && dataModal.urlFile != '' && dataModal.urlFile != undefined" @click="showImages(dataModal.urlFile)" class="w-25" color="success">Lihat Bukti</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px">
                        <CCol sm="6"></CCol>
                        <CCol sm="2">
                            <CButton style="width: 100%!important" @click="modalApprove = false" class="btn-cancel">Kembali</CButton>
                        </CCol>
                        <CCol sm="2">
                            <CButton @click="openKeterangan('R')" class="w-100" color="danger">Reject</CButton>
                        </CCol>
                        <CCol sm="2">
                            <CButton @click="openKeterangan('A')" class="w-100" color="primary">Approve</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="md"
            :centered="true"
            color="white"
            :show.sync="modalKeterangan"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Keterangan <span v-if="flag == 'R'">Reject</span><span v-if="flag == 'A'">Approve</span></div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalKeterangan = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="12">
                            Masukan Keterangan
                        </CCol>
                        <CCol sm="12 mt-2">
                            <textarea class="form-control" v-model="keterangan" placeholder="Keterangan"/>
                        </CCol>
                    </CRow>
                </div>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="6"></CCol>
                    <CCol sm="3">
                        <CButton style="width: 100%!important" @click="modalKeterangan = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                    <CCol sm="3">
                        <CButton @click="goSave()" class="w-100" color="primary">Simpan</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalAdd"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            Tambah Manual Tes Mandiri
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalAdd = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow>
                        <CCol sm="6">
                            <label>Nama Pegawai</label>
                            <div class="autocomplete">
                                <input type="text"
                                        class="form-control"
                                        @click="toggleVisibleAddPegawai()"
                                        @blur="toggleCloseVisibleAddPegawai()"
                                        v-model="queryAddPegawai"
                                        v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                                        @keydown.up="upAddPegawai"
                                        @keydown.down="downAddPegawai"
                                        @keydown.enter="selectItemAddPegawai"
                                        placeholder="Pilih Pegawai"
                                >
                                <div class="popovers" v-show="visibleAddPegawai">
                                    <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0" ref="optionsList">
                                        <ul>
                                        <li v-for="(match, index) in matchesAddPegawai"
                                            :key="index"
                                            :class="{ 'selected': (selectedAddPegawai == index)}"
                                            @click="itemClickedAddPegawai(index)"
                                            v-text="match['text']"></li>
                                        </ul>
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">
                                        Data Tidak Ditemukan
                                    </div>
                                    <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">
                                        Start Typing...
                                    </div>
                                </div>
                            </div>
                        </CCol>
                        <CCol sm="6">
                            <label>Jabatan</label>
                            <input disabled v-model="jabatanAddPegawai" placeholder="Jabatan" class="form-control">
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="6">
                            <label>Jenis Tes</label>
                            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataJenis" class="form-control" v-model="jenis" placeholder="Pilih Jenis Tes"></model-select>
                        </CCol>
                        <CCol sm="6">
                            <label>Tanggal Hasil</label>
                            <input type="date" v-model="tanggalHasil" class="form-control">
                        </CCol>
                    </CRow>
                    <CRow class="mt-2">
                        <CCol sm="6">
                            <label>Hasil Tes</label>
                            <model-select :isDisabled="jenis.value == ''" style="background-color:rgba(249, 250, 252, 1)" :options="dataHasil" class="form-control" v-model="hasil" placeholder="Pilih Hasil Tes"></model-select>
                        </CCol>
                        <CCol sm="6">
                            <label>Bukti Tes</label>
                            <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataBukti" class="form-control" v-model="bukti" placeholder="Pilih Bukti Tes"></model-select>
                        </CCol>
                    </CRow>
                    <CRow v-if="bukti.value == '1'" class="mt-2">
                        <CCol sm="6">
                            <label>Foto/Image File</label>
                            <div v-if="urlImage == '' || urlImage == 'null'">
                                <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                                <div :class="classSignature">+</div>
                            </div>
                            <div v-else>
                                <img :src="urlImage" width="56" height="56" />
                                <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                            </div>
                        </CCol>
                    </CRow>
                    <CRow v-if="bukti.value == '2'" class="mt-2">
                        <CCol sm="6">
                            <label>PDF File</label>
                            <div>
                                <CButton v-if="file == ''" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Dokumen</CButton>
                                <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display:none"  id="inputFile" class="hide" />
                            </div>
                            <!--  -->
                            <p v-if="file != ''" class="font-weight-bold"><span class="mr-3">{{fileName}}</span></p>
                        </CCol>
                    </CRow>
                    <CRow class="mt-4" v-if="errAlert != ''">
                        <CCol sm="6"></CCol>
                        <CCol sm="6">
                            <span class="text-danger">{{errAlert}}</span>
                        </CCol>
                    </CRow>
                    <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                        <CCol sm="6"></CCol>
                        <CCol sm="3">
                            <CButton style="width: 100%!important" @click="modalAdd = false" class="btn-cancel">Kembali</CButton>
                        </CCol>
                        <CCol sm="3">
                            <CButton @click="submitAdd()" class="w-100" color="primary">Simpan</CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableDaftarTesMandiri'
import {DataApi, DataApiUpload} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            // filter
            searchTanggal: '',

            // data search select kantor
            idPegawai: '',

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Pegawai', 'No KTP', 'Tes', 'Hasil', 'File', 'Status', 'Action'],
            dataTd: [['nama', 'nik'], 'noKtp', 'testing', 'hasil', 'file', 'status', 'action'],
            styleTable: ['175px', '125px', '125px', '125px', '75px', '175px', '100px'],
            classReload: 'reloadOff',
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            tipe: 'C',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            
            // datas
            datas: [],

            //error
            errorMessage: '',
            modalApprove: false,
            dataModal: [],
            modalKeterangan: false,
            keterangan: '',
            flag: '',
            dataStatus: [],
            selectedStatus: {
                text: '',
                value: ''
            },

            // ADD
            lvl: '',
            organisasi: '',

            modalAdd: false,

            // data add pegawai
            dataAddPegawai: [],
            titleAddPegawai:"Pilih Pegawai",
            selectedItemAddPegawai: null,
            selectedAddPegawai: 0,
            queryAddPegawai: '',
            visibleAddPegawai: false,
            idAddPegawai: '',
            jabatanAddPegawai: '',

            dataJenis: [],
            jenis: {
                value: '',
                text: ''
            },
            dataHasil: [],
            hasil: {
                value: '',
                text: ''
            },
            dataBukti: [],
            bukti: {
                value: '',
                text: ''
            },
            tanggalHasil: '',
            classSignature: 'cards-image',

            //image
            urlImage: '',
            showImage: '',
            urlPath: '',

            //pdf
            file: '',
            fileName: '',
            fileSize: '',
            urlFile: '',
            tempFile: [],
            errAlert: '',
            flagSearch: false
        }
    },
    computed: {
        matchesAddPegawai() {
            if (this.queryAddPegawai == '') {
                return [];
            }
            return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()))
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        idPegawai() {
            this.flagSearch = true
        },
        selectedStatus() {
            this.flagSearch = true
        },
        searchTanggal() {
            this.flagSearch = true
        },
        queryAddPegawai() {
            if(this.queryAddPegawai == '') {
                this.idAddPegawai = ''
                this.jabatanAddPegawai = ''
            }
            this.getDataAddPegawai()
        },
        modalApprove() {
            if(this.modalApprove == false) {
                this.dataModal = []
            }
        },
        modalKeterangan() {
            if(this.modalKeterangan == false) {
                this.keterangan = ''
                this.flag = ''
            }
        },
        selectedStatus() {
            this.page = 1
        },
        bukti() {
            if(this.bukti.value == '1') {
                this.file = ''
                this.fileName = ''
                this.fileSize = ''
                this.urlFile = ''
                this.tempFile = []
            } else if(this.bukti.value == '2') {
                this.urlImage = ''
                this.showImage = ''
                this.urlPath = ''
            }
        },
        jenis() {
            this.hasil.value = ''
            this.hasil.text = ''
            if(this.jenis.text == 'RTA') {
                this.dataHasil = [
                    { text: 'Reaktif', value: '1' },
                    { text: 'Non Reaktif', value: '2' },
                ]
            } else {
                this.dataHasil = [
                    { text: 'Positif', value: '1' },
                    { text: 'Negatif', value: '2' },
                ]
            }
        },
        modalAdd() {
            if(this.modalAdd == false) {
                this.urlImage = ''
                this.showImage = ''
                this.urlPath = ''
                this.file = ''
                this.fileName = ''
                this.fileSize = ''
                this.urlFile = ''
                this.tempFile = []
                this.dataAddPegawai = []
                this.queryAddPegawai = ''
                this.idAddPegawai = ''
                this.jabatanAddPegawai = ''
                this.tanggalHasil = ''
                this.classSignature = 'cards-image'
                this.dataBukti = []
                this.dataHasil = []
                this.dataJenis = []
                this.bukti.value = ''
                this.bukti.text = ''
                this.hasil.value = ''
                this.hasil.text = ''
                this.jenis.value = ''
                this.jenis.text = ''
                this.errAlert = ''
                this.getDataJenis()
                this.getDataHasil()
                this.getDataBukti()
            }
        }
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaKantor.toLowerCase() < b.namaKantor.toLowerCase()) {
                        return -1
                    }
                    if (a.namaKantor.toLowerCase() > b.namaKantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.jam.toLowerCase() < b.jam.toLowerCase()) {
                        return -1
                    }
                    if (a.jam.toLowerCase() > b.jam.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let idPegawai = this.idPegawai
            let tanggal = this.searchTanggal
            let page = this.page
            let status = this.selectedStatus.value

            let payload = {
                limit: limit,
                idPegawai: idPegawai,
                tanggal: tanggal,
                pageIn: page,
                status: status
            }
            DataApi.post("rta/mandiri/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.idPegawai = ''
            this.selectedStatus.value = ''
            this.selectedStatus.text = ''
            this.searchTanggal = ''
            this.flagSearch = true
            this.getDataStatus()
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        openKeterangan(val) {
            this.flag = val
            this.modalKeterangan = true
        },
        goSave() {
            this.modalKeterangan = false
            let unix = this.dataModal.unix
            let payload = {
                approve: this.flag,
                keterangan: this.keterangan,
                unix: unix
            }
            DataApi.post("rta/mandiri/approve", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.modalApprove = false
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        submitAdd() {
            if(this.bukti.value == '') {
                this.errAlert = '*Harap melengkapi data terlebih dahulu'
            } else {
                if(this.bukti.value == '1') {
                    if(this.idAddPegawai != '' && this.jenis.value != '' && this.tanggalHasil != '' && this.hasil.value != '' && this.urlImage != '') {
                        this.saveImage()
                        this.$store.state.loadingScreen = true
                        this.errAlert = ''
                    } else {
                        this.errAlert = '*Harap melengkapi data terlebih dahulu'
                    }
                } else if(this.bukti.value == '2') {
                    if(this.idAddPegawai != '' && this.jenis.value != '' && this.tanggalHasil != '' && this.hasil.value != '' && this.file != '') {
                        this.uploadFile()
                        this.$store.state.loadingScreen = true
                        this.errAlert = ''
                    } else {
                        this.errAlert = '*Harap melengkapi data terlebih dahulu'
                    }
                }
            }
        },

        submitSave(num) {
            let file = ''
            if(num == '1') {
                file = this.urlPath
            } else if(num == '2') {
                file = this.urlFile
            }
            let payload = {
                idPegawai: this.idAddPegawai,
                jenis: this.jenis.value,
                status: this.hasil.value,
                tanggal: this.tanggalHasil,
                tipe: 'C',
                unix: '',
                urlFile: file
            }
            DataApi.post("rta/mandiri/simpan", payload)
            .then(res => {
                    this.$store.state.loadingScreen = true
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.modalAdd = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.dataModal = generate
            this.modalApprove = true
        },
        showImages(value) {
            window.open(
            value,
            '_blank' // <- This is what makes it open in a new window.
            );
        },
        getDataStatus() {
            this.dataStatus = [
                { text: 'Semua', value: '' },
                { text: 'Approve', value: 'A' },
                { text: 'Reject', value: 'R' },
                { text: 'Waiting', value: 'W' },
            ]
        },
        getDataHasil() {
            this.dataHasil = [
                { text: 'Reaktif', value: '1' },
                { text: 'Non Reaktif', value: '2' },
            ]
        },
        getDataBukti() {
            this.dataBukti = [
                { text: 'Foto/Image', value: '1' },
                { text: 'PDF File', value: '2' },
            ]
        },
        getDataJenis() {
            DataApi.get("rta/jenis/lihat")
            .then(res => {
                this.dataJenis = []
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    var i 
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].keterangan
                        }
                        this.dataJenis.push(onPush)
                    }
                }
            })
        },

        /**
         * ADD PESERTA
         */
        getDataAddPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryAddPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataAddPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik,
                        jabatan: tempData[i].jabatan
                    }
                    this.dataAddPegawai.push(onPush)
                }
            })
        },
        toggleVisibleAddPegawai() {
            this.visibleAddPegawai = true;
        },
        hideAddPegawai() {
            this.visibleAddPegawai = false;
        },
        toggleCloseVisibleAddPegawai() {
            setTimeout(this.hideAddPegawai, 1000);
        },
        itemClickedAddPegawai(index) {
            this.selectedAddPegawai = index;
            this.selectItemAddPegawai();
        },
        selectItemAddPegawai() {
            if (!this.matchesAddPegawai.length) {
            return;
            }
            this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
            this.visibleAddPegawai = false;
            this.queryAddPegawai = this.selectedItemAddPegawai.text
            this.idAddPegawai = this.selectedItemAddPegawai.value
            this.jabatanAddPegawai = this.selectedItemAddPegawai.jabatan
            if (this.shouldReset) {
            this.queryAddPegawai = '';
            this.selectedAddPegawai = 0;
            }
        },
        upAddPegawai() {
            if (this.selectedAddPegawai == 0) {
            return;
            }
            this.selectedAddPegawai -= 1;
            this.scrollToItemAddPegawai();
        },
        downAddPegawai() {
            if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
            return;
            }
            this.selectedAddPegawai += 1;
            this.scrollToItemAddPegawai();
        },
        scrollToItemAddPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
        },

        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.submitSave('1')
                    } else {
                        alert('Upload Photo Failed !')
                        this.loading = false
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.submitSave('1')
            } else {
                this.urlPath = this.urlImage
                this.submitSave('1')
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },

        loadFile(e) {
            let files = document.getElementById('inputFile').files[0]
            this.file = files
            this.fileName = files.name
            this.fileSize = files.size
        },
        uploadFile() {
            if(parseInt(this.fileSize) > 2000000) {
                alert("Maaf, Maksimal lampiran 2MB")
                setTimeout(this.clearFile, 200);
            } else {
                this.prosessUpload()
            }
        },
        prosessUpload() {
            if (this.file != '') {
                let imageData = this.file

                const fd = new FormData()
                fd.append('file', imageData)

                DataApiUpload.post('upload', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlFile = response.data.path
                        this.submitSave('2')
                    } else {
                        alert('Upload File Failed !')
                    }
                });
            } else if(this.file == '') {
                this.urlFile = ''
            }
        },
        clearFile() {
            this.deskripsi = ''
            this.fileName = ''
            this.fileSize = ''
            this.urlFile = ''
            this.file = ''
        },

        getDataToken() {
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                }
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
        this.getDataStatus()
        this.getDataJenis()
        this.getDataHasil()
        this.getDataBukti()
    },
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 64px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.err-sig {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted red;
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
</style>